module.exports = __webpack_public_path__ + "static/media/test1_2.a9954555.png";